import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useRef, useState } from 'react';
export function useStatefulRef() {
  var initialVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  // eslint-disable-next-line prefer-const
  var _useState = useState(initialVal),
      _useState2 = _slicedToArray(_useState, 2),
      cur = _useState2[0],
      setCur = _useState2[1];

  var _useRef = useRef({
    current: cur
  }),
      ref = _useRef.current;

  Object.defineProperty(ref, 'current', {
    get: function get() {
      return cur;
    },
    set: function set(value) {
      if (!Object.is(cur, value)) {
        cur = value;
        setCur(value);
      }
    }
  });
  return ref;
}